import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={950}
    height={161}
    viewBox="0 0 950 161"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M-31 403.714L981 403.714M-31 367.154L981 367.154M-31 330.594L981 330.594M-31 294.035L981 294.035M-31 257.475L981 257.475M-31 220.915L981 220.915M-31 184.355L981 184.355M-31 147.796L981 147.795M-31 111.236L981 111.236M-31 74.676L981 74.6759M-31 38.1162L981 38.1162M-31 1.55638L981 1.55634M-31 -35.0034L981 -35.0034M-31 -71.5631L981 -71.5632M-31 -108.123L981 -108.123M-31 -144.683L981 -144.683M-20.7967 439L-20.7967 -181M15.7394 439L15.7394 -181M52.2755 439L52.2755 -181M88.8117 439L88.8116 -181M125.348 439L125.348 -181M161.884 439L161.884 -181M198.42 439L198.42 -181M234.956 439L234.956 -181M271.492 439L271.492 -181M308.028 439L308.028 -181M344.564 439L344.564 -181M381.101 439L381.101 -181M417.637 439L417.637 -181M454.173 439L454.173 -181M490.709 439L490.709 -181M527.245 439L527.245 -181M563.781 439L563.781 -181M600.317 439L600.317 -181M636.853 439L636.853 -181M673.39 439L673.389 -181M709.926 439L709.926 -181M746.462 439L746.462 -181M782.998 439L782.998 -181M819.534 439L819.534 -181M856.07 439L856.07 -181M892.606 439L892.606 -181M929.142 439L929.142 -181M965.678 439L965.678 -181"
      stroke="white"
      strokeOpacity={0.2}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SVGComponent;
